import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Switch } from "@mantine/core";
import { IconCloudUpload } from "@tabler/icons-react";
import { submitRunPodJob } from "../api/runpod";
import GenerateForm from "../components/generate/GenerateForm";

export default function ServerlessPage() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [enhanceBackground, setEnhanceBackground] = useState(false);

  return (
    <GenerateForm
      description="Serverless"
      submitLabel="Run"
      submitIcon={<IconCloudUpload size={16} />}
      busyMessage="Submitting…"
      onSubmit={async (file) => {
        const job = await submitRunPodJob(instance, file, enhanceBackground);
        navigate(`/gallery/serverless/${job.id}`);
      }}
    >
      <Switch
        label="Enhance background"
        description="Pre-process the image with remove.bg and replace the background with a chroma key color"
        checked={enhanceBackground}
        onChange={(e) => setEnhanceBackground(e.currentTarget.checked)}
      />
    </GenerateForm>
  );
}
